import type {RepositoryItem, SuggestedIssue, SuggestedPullRequest} from '../api/repository/contracts'
import {PickerItem} from './common/picker-list'
import {ItemState} from './item-state'
import styles from './suggested-item-option.module.css'

interface SuggestedItemOptionProps extends React.LiHTMLAttributes<HTMLLIElement> {
  item: RepositoryItem
}

export const SuggestedItemOption: React.FC<SuggestedItemOptionProps> = ({item, ...itemProps}) => {
  return (
    <PickerItem {...itemProps}>
      <div className={styles.Box}>
        <div className={styles.Box_1}>
          <ItemState
            type={item.type}
            state={item.state}
            stateReason={(item as SuggestedIssue)?.stateReason}
            isDraft={!!(item as SuggestedPullRequest).isDraft}
            isBlocked={false}
          />
        </div>
        <span>{item.title}</span>
        <span className={styles.Text}>{`#${item.number}`}</span>
      </div>
    </PickerItem>
  )
}
